<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="true"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<div class="content-page">
    <div class="content p-1 crumbs">
        <div class="content text-dark">
            <div class="d-flex align-items-center">
                <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                    <ol class="breadcrumb text-capitalize text-dark h5">
                        <li class="breadcrumb-item"><a [routerLink]="['/reports']" class="text-secondary">Reports</a></li>
                        <li class="breadcrumb-item text-secondary" aria-current="page">Inventory Tax Panel</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    
    @if (security.permitted('reports', 'inventory tax', 'view')) {
        <aside>            
            <form [formGroup]="form">
                <div class="form-group">
                    <select class="form-control form-control-sm" name="lot" id="lot-filter" formControlName="lotId">
                        <option value="0">All Lots</option>
                        @for (lot of lots; track lot.id) {
                            <option value="{{lot.id}}">{{lot.contact.name}}</option>
                        }
                    </select>
                </div>
                <div class="form-group">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <span class="input-group-text">from</span>
                        </div>
                        <input type="date" select class="form-control form-control-sm" name="from" id="from-filter" formControlName="from" />
                    </div>
                </div>
                <div class="form-group">
                    
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <span class="input-group-text">to</span>
                        </div>
                        <input type="date" select class="form-control form-control-sm" name="to" id="to-filter" formControlName="to" />
                    </div>
                </div>
            </form>
        </aside>

        <main>
            <h1 class="text-center">Dealer's Motor Vehicle Inventory Tax QC Report</h1>

            @if (entries && (entries.length > 0)) {
                <div class="detail">
                    <div class="entity">
                        <h4>{{summary.name}}</h4>
                        <p>{{summary.address}}</p>
                        <p>{{summary.cityStateZip}}</p>
                    </div>

                    <div class="gov">
                        <div class="gov-item">
                            <p>Report Covers (Month Year)</p>
                            <p>{{form.get('from').value | date:'MMM yyyy'}}</p>
                        </div>
                        <div class="gov-item">
                            <p>Account Number</p>
                            <p>{{summary.einNumber}}</p>
                        </div>
                        <div class="gov-item">
                            <p>General Distinguishing Number</p>
                            <p>{{summary.dealerNumber}}</p>
                        </div>
                    </div>
                </div>

                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col">Sold</th>
                            <th scope="col">Vehicle</th>
                            <th scope="col">VIN</th>
                            <th scope="col">Customer</th>
                            <th scope="col">Type</th>
                            <th class="text-right" scope="col">Rate</th>
                            <th class="text-right" scope="col">Price</th>
                            <th class="text-right" scope="col">Unit Property Tax</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of entries; track item.id) {
                            <tr>
                                <td>{{item.sold | date:'shortDate'}}</td>
                                <td>{{item.yearMakeModel}}</td>
                                <td>{{item.vin}}</td>
                                <td>{{item.buyer}}</td>
                                <td>{{item.taxType}}</td>
                                <td class="text-right">{{item.taxRate | percent:'1.6-6'}}</td>
                                <td class="text-right">{{item.price | currency}}</td>
                                <td class="text-right">{{item.tax | currency}}</td>
                            </tr>
                        }

                        @if (summary) {
                            <tr class="total">
                                <td colspan="6"></td>
                                <td class="text-right">{{summary.price | currency}}</td>
                                <td class="text-right">{{summary.tax | currency}}</td>
                            </tr>
                        }
                    </tbody>
                </table>

                <section class="summary">
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th scope="col">Type</th>
                                <th class="text-right" scope="col">Count</th>
                                <th class="text-right" scope="col">Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (group of grouped | keyvalue; track group.key) {
                                <tr>
                                    <td>{{group.key}}</td>
                                    <td class="text-right">{{group.value.count | number:'1.0-0'}}</td>
                                    <td class="text-right">{{group.value.price | currency}}</td>
                                </tr>
                            }
                        </tbody>
                    </table>

                    @if (grouped && grouped['MV']) {
                        <div>
                            <h5>Independent cross-check (may round-off differently but should be very close)</h5>
                            <ul class="list-group flexed">
                                <li class="list-group-item">
                                    <p>Average MV Inventory Tax Rate</p>
                                    <p>{{((grouped['MV'].count > 0) ? grouped['MV'].rate / grouped['MV'].count : 0) | percent:'1.10-10'}}</p>
                                </li>
                                <li class="list-group-item">
                                    <p>Total MV Sales Amount</p>
                                    <p>{{grouped['MV'].price | currency}}</p>
                                </li>
                                <li class="list-group-item total">
                                    <p>Total Tax From Total MV Sales (average tax rate times total sales)</p>
                                    <p>{{((grouped['MV'].count > 0) ? (grouped['MV'].price * (grouped['MV'].rate) / grouped['MV'].count) : 0) | currency}}</p>
                                </li>
                            </ul>
                        </div>
                    }
                </section>
            }
        </main>
    }
</div>
